import { render, staticRenderFns } from "./MeasureBox.vue?vue&type=template&id=2da7e5b8&scoped=true&"
import script from "./MeasureBox.vue?vue&type=script&lang=js&"
export * from "./MeasureBox.vue?vue&type=script&lang=js&"
import style0 from "./MeasureBox.vue?vue&type=style&index=0&id=2da7e5b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da7e5b8",
  null
  
)

export default component.exports